import * as Yup from 'yup';
import { VALIDATION_MESSAGE } from '../Constants/Constants';


const capitalizeFirstLetter = (string: string): string => {
    return string.charAt(0).toUpperCase() + string.slice(1);
}

export const validateString = (label: any, max: any = 999999999, min: any = 0) => {
    return Yup.string()
        .trim()
        .required(VALIDATION_MESSAGE?.ANY_ENTER + ` ${label}. `)
        .max(max, capitalizeFirstLetter(label) + VALIDATION_MESSAGE?.ANY_MAX + max + '.')
        .min(min, capitalizeFirstLetter(label) + VALIDATION_MESSAGE?.ANY_MIN + min + '.')
};



export const validateEditorStringData = (label: any, max: any, min: any = null) => {
    return Yup.string()
        .trim()
        .nullable()
        .required(VALIDATION_MESSAGE?.ANY_ENTER + ` ${label}. `)
        .test('count-length-after-removing-tags', label + VALIDATION_MESSAGE?.ANY_MAX + max + '.', function (value: any) {
            if (max !== null) {
                return value.replace(/(<([^>]+)>)/ig, '')?.length < max + 1;
            }
            return true;
        })
        .test('check-min-count-length-after-removing-tags', `${label} ${VALIDATION_MESSAGE.ANY_MIN} ${min}.`, function (value = '') {
            if (min !== null) {
                const cleanValue = value.replace(/(<([^>]+)>)/ig, '');
                return cleanValue.length >= min;
            }
            return true;
        });
}

export const validateOptionalEditorStringData = (label: any, max: any, min: any = null) => {
    return Yup.string()
        .trim()
        .nullable()
        .optional()
        .test('count-length-after-removing-tags', label + VALIDATION_MESSAGE?.ANY_MAX + max + '.', function (value: any) {
            if (max !== null) {
                return value.replace(/(<([^>]+)>)/ig, '')?.length < max + 1;
            }
            return true;
        })
        .test('check-min-count-length-after-removing-tags', `${label} ${VALIDATION_MESSAGE.ANY_MIN} ${min}.`, function (value = '') {
            if (min !== null && value) {
                const cleanValue = value.replace(/(<([^>]+)>)/ig, '');
                return cleanValue.length >= min;
            }
            return true;
        });
}

export const validateStringData = (label: any, max: any = 999999999, min: any = 0) => {
    return Yup.string()
        .trim()
        .nullable()

        // .max(max, label + VALIDATION_MESSAGE?.ANY_MAX + max + '.')
        // .min(min, label + VALIDATION_MESSAGE?.ANY_MIN + min + '.')

        .max(max, capitalizeFirstLetter(label) + VALIDATION_MESSAGE?.ANY_MAX + max + '.')
        .min(min, capitalizeFirstLetter(label) + VALIDATION_MESSAGE?.ANY_MIN + min + '.')
        .test('no-leading-trailing-space', 'Paper description must have a single space between words.', value => {
            if (value && (value.startsWith(' ') || value.endsWith(' '))) {
                return false;
            }
            else if (value && / {2,}/.test(value)) {
                return false;
            }
            return true;
        })
};



export const validateStringCharacter = (label: any, max: any = 999999999, min: any = 0) => {
    return Yup.string().trim()
        .transform(value => value.trim())
        .test('single-space', `${label} must have only one space.`, value => {
            if (value && /\s{2,}/.test(value)) {
                return false;
            }
            return true;
        })
        .required(VALIDATION_MESSAGE?.ANY_ENTER + ` ${label}. `)
        .max(max, `${label} ${VALIDATION_MESSAGE?.ANY_MAX} ${max} characters.`)
        .min(min, `${label} ${VALIDATION_MESSAGE?.ANY_MIN} ${min} characters.`);

};

export const validateDateString = (label: any, max: any = 999999999) => {
    return Yup.string()
        .required(VALIDATION_MESSAGE?.ANY_SELECT + ` ${label} `)
        .max(max, label + VALIDATION_MESSAGE?.ANY_MAX + max)
};

export const validateOptional = () => {
    return Yup.string()
        .optional()
};

export const validateNumber = (label: any, maxLength: number = 20) => {
    return Yup.string()
        .required(VALIDATION_MESSAGE?.ANY_ENTER + ` ${label}. `)
        .typeError(`${label} must be a number`)
        .test(`${label} cannot be only a dot`, "Please enter decimal values", (value) => {
            return value !== '.';
        })
        // .positive(`${label} must be a positive number`)
        // .integer(`${label} must be an integer`)
        .max(Number.MAX_SAFE_INTEGER, `${label} is too large`)
        .test("maxDigits", `${label} must have at most ${maxLength} digits`, (value) => {
            const stringValue = String(value);
            return stringValue.length <= maxLength;
        })
};

export const validateNumberData = (maxLength: number = 20) => {
    return Yup.string()
        .nullable()
        .max(Number.MAX_SAFE_INTEGER, ` is too large`)
        .test("maxDigits", ` must have at most ${maxLength} digits`, (value) => {
            const stringValue = String(value);
            return stringValue.length <= maxLength;
        })
};

export const validateNumberWith = (label: any, maxLength: number = 4000000, minLength: number = 0) => {
    return Yup.number()
        .required(`${capitalizeFirstLetter(label)} is required`)
        .typeError(`Please enter ${label}`)
        .positive(`${capitalizeFirstLetter(label)} must be positive`)
        .integer(`${capitalizeFirstLetter(label)} must be an integer`)
        .min(minLength, `${capitalizeFirstLetter(label)} must be at least ${minLength}.`)
        .max(maxLength, `${capitalizeFirstLetter(label)} must be less or equal to ${maxLength}.`)

};

export const validateNumberWithEvent = (label: any, maxLength: number = 1, minLength: number =1) => {
    return Yup.number()
        .required(`${capitalizeFirstLetter(label)} is required`)
        .typeError(`Please enter ${label}.`)
        .positive(`${capitalizeFirstLetter(label)} must be positive`)
        .integer(`${capitalizeFirstLetter(label)} must be an integer`)
        .min(minLength, `${capitalizeFirstLetter(label)} must be at least ${minLength}.`)
        .max(maxLength, `${capitalizeFirstLetter(label)} must be below ${maxLength}.`)

};

export const validateNumberCapicityWith = (label: any, maxLength: number = 4000000, minLength: number = 0) => {
    return Yup.number()
        .required(`${capitalizeFirstLetter(label)} is required`)
        .typeError(`Please enter ${label}`)
        .positive(`${capitalizeFirstLetter(label)} must be positive`)
        .integer(`${capitalizeFirstLetter(label)} must be an integer`)
        .min(minLength, `${capitalizeFirstLetter(label)} must be at least ${minLength}`)
        .max(maxLength, `The`)

};



export const validateEmail = (label: any) => {
    return Yup.string()
        .email('Please enter a valid Email Address.')
        .required(VALIDATION_MESSAGE?.ANY_ENTER + " " + label + ".")
        .trim(VALIDATION_MESSAGE?.ANY_ENTER + " " + label)
        .max(150, VALIDATION_MESSAGE?.EMAIL_MAX)
        .matches(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/, 'Please enter a valid Email Address')
};

export const validateBoolean = () => {
    return Yup.boolean()
};


export const allowedImagesTypes = ["image/jpeg", "image/png", "image/jpg", "image/webp"]
export const validateFile = (label: any, allowedFileTypes: any, maxSize: any = 10,) => {
    const maxSizeInBytes = maxSize * 1024 * 1024;


    return Yup.mixed()
        .nullable()
        .test("required", `${VALIDATION_MESSAGE?.ANY_CHOOSE} ${label}`, (fileList: any) => {
            return fileList && fileList?.length > 0;
        })
        .test("fileType", `${VALIDATION_MESSAGE?.USER_UNSUPPORTED} Please choose a ${label} using ${allowedFileTypes.join(", ")} format.`, (fileList: any) => {
            if (fileList && fileList?.length > 0) {
                return allowedFileTypes.includes(fileList[0].type);
            }
            return true;
        })
        .test("fileSize", `${label} size should be less than ${maxSizeInBytes / (1024 * 1024)} MB.`, (fileList: any) => {
            // .test("fileSize", `${VALIDATION_MESSAGE?.USER_UNSUPPORTED} ${label} size should be less than ${maxSizeInBytes / (1024 * 1024)} MB.`, (fileList: any) => {
            if (fileList && fileList?.length > 0) {
                return fileList[0].size <= maxSizeInBytes;
            }
            return true;
        });

};

export const validateSelection = (label: any) => {
    return Yup.mixed()
        .test("required", VALIDATION_MESSAGE?.ANY_SELECT + ` ${label} `, (value: any) => {
            return !(value && value.length === 0);
        });
};

export const validateImageFile = () => {
    return Yup.mixed()
        .nullable()
        .test("fileType", VALIDATION_MESSAGE?.USER_UNSUPPORTED + "  Please choose an icon using .jpeg, .png, .jpg, .gif, .webp format. ", (file: any) => {
            if (typeof file == 'undefined') {
                return true;
            }
            if (file.length > 0 && file[0].type) {
                var file_type = file.length && ["image/jpeg", "image/png", "image/jpg", "image/webp"].includes(file[0].type)
                if (file_type) {
                    return file_type;
                }
                else {

                    return file_type;
                }
            }
            else {
                return true;
            }
        })
};

export const validateDate = (label: any) => {
    return Yup.date()
        .required()
        .nullable()
        .required(VALIDATION_MESSAGE?.ANY_REQUIRED + ` ${label} `);
};



export const validatePassword = (label: any) => {
    Yup.object().shape({
        password: Yup.string()
            .required(VALIDATION_MESSAGE?.NEW_PASSWORD_REQUIRED)
            .min(8, VALIDATION_MESSAGE?.NEW_PASSWORD_MIN_CHAR)
            .max(16, VALIDATION_MESSAGE?.NEW_PASSWORD_MAX_CHAR)
            .matches(/^\S*$/, VALIDATION_MESSAGE?.NO_SPACE_ALLOWED)
            .matches(/^(?=.*[A-Z])/, VALIDATION_MESSAGE?.PASSWORD_UPPER_CASE)
            .matches(/^(?=.*[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~])/, VALIDATION_MESSAGE?.PASSWORD_SPECIAL_CASE)
            .matches(/^(?=.{6,20}$)\D*\d/, VALIDATION_MESSAGE?.PASSWORD_NUMBER_CASE)
            // .notOneOf([Yup.ref('old_password')], VALIDATION_MESSAGE?.PASSWORD_OLD_NOT_SAME)
            .test('password-match', 'New password cannot be  same as the old password', function (value) {
                return value !== this.parent.old_password;
            })
    })
}



export const validateSelectionDropDown = (label: any) => {
    return Yup.string().required(VALIDATION_MESSAGE?.ANY_SELECT + ` ${label}. `)
};